import React from 'react'
// components
import DataHubAPI from 'containers/DataHub/layers/API/index'
import DataHub from 'components/PageComponents/DataHub/Main/index'

const DataHubContainer: React.FC = () => {
  return (
      <DataHubAPI>
        <DataHub />
      </DataHubAPI>
  )
}

export default DataHubContainer
